import { useMutation } from '@tanstack/react-query';

import { MembershipType } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

//http://192.168.1.98:8000/sp-core/{parking_pk}/memberships/membership-type/{id}/deactivate/
const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:typeId/deactivate/';

type MutationFnType = typeof mutationFn;

type DTO = {
    parkingId: string;
    typeId: string;
};

const mutationFn = ({ parkingId, typeId }: DTO): Promise<MembershipType> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, typeId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeactivateMembershipType };
